import { listOfStringsTypeFiltersCombiner } from "./listOfStringsTypeFiltersCombiner";
import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const appliedAccountIdsSelector = (state: RootState) => {
  const filters = resourceExplorerAppliedFiltersSelector(state);

  return listOfStringsTypeFiltersCombiner("account", filters);
};
